import type { PageType } from 'types/page_type';

export const usageNotesForAdminsPage: Readonly<PageType> = {
  path: '/usage-notes/for-admins',
  title: `SIGNATE Cloud利用上の注意事項について（管理者向け）`,
  description: `SIGNATE Cloud利用上の注意事項について（管理者向け）`,
};
